import aboutBanerJoson from "./aboutBanner.json";
import "./style.scss";

export const AboutBanner = () => {
    return (
        <>
            <section
                style={{ backgroundColor: "#C2975E1A" }}
                className="py-5 about-banner"
            >
                <div className="container text-center py-4 py-md-5">
                    <span
                        className="font-color px-3 py-2 rounded-pill d-inline-block mb-3 about-badge"
                        style={{ backgroundColor: "#305F521A" }}
                    >
                        {aboutBanerJoson?.info}
                    </span>
                    <h1 className="bebas-neue-regular about-title mb-0">
                        {aboutBanerJoson?.title1}
                    </h1>
                    <h1 className="bebas-neue-regular text-color about-title mb-3">
                        {aboutBanerJoson?.title2}
                    </h1>
                    <p
                        className="about-desc mx-auto"
                        dangerouslySetInnerHTML={{
                            __html: aboutBanerJoson?.subContent,
                        }}
                    />
                </div>
            </section>
        </>
    );
};
